import React, { Fragment, useContext, useState } from "react";
import { FormDataFeild } from "../../../../reuseable/Inputs";
import { useMutation } from "react-query";
import { DELETE_IMAGE, Upload_Image } from "../../../../Apis/userApi/UserApi";
import { Dialog } from "primereact/dialog";
import { IsLoadingResponse, ToastMessage } from "../../../../utils/Helper";
import "cropperjs/dist/cropper.css";
import {
  Email,
  Phone,
  Submit,
  TYPE_FELDS,
  TypeNumber,
  DialCode,
  optionsDialCode,
  FileType,
  NOT_FOUND_IMAGE,
  UpdateCustomerTitle,
  Name,
  CreateCustomerTitle,
  WP_GROUP_ID,
} from "../../../../constants";
import { Button } from "primereact/button";
import { Col, Form, Row } from "react-bootstrap";
import { Card, CardBody } from "reactstrap";
import { createCustomerSchema } from "../../../../utils/validationSchema";
import CropImagePopup from "../../../CropImagePopup";
import SweetConfirmation from "../../../../reuseable/sweetConfirmation";
import CustomerContext from "../../../../context/CustomerContext/CustomerContext";
import {
  Create_Customer,
  Put_Update_Customer,
} from "../../../../Apis/customerApi/customerApi";
import { InputSwitch } from "primereact/inputswitch";

const CustomerCreateFormPopup = (props) => {
  const {
    setFormData,
    orgId,
    isEdit,
    setDialogs,
    formData,
    dialog,
    errors,
    setErrors,

    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
    aspect,
  } = useContext(CustomerContext);
  const { handleOpenandClosePopup, refetch, emptyData } = props;
  const [dialogModal, setdialogsModal] = useState(false);

  /**
   *
   * @param {event } e
   * create Company & update Company
   */

  const { mutate: createCustomer, isLoading: createCompanyLoader } =
    useMutation((formData) => Create_Customer(formData), {
      onSuccess: (response) => {
        if (response.status === 200) {
          refetch();
          setDialogs(false);
          emptyData();
          setErrors({});
          ToastMessage(response.status, response.data.message);
        }
      },
    });

  const { mutate: updateCustomer, isLoading: updateCompanyLoader } =
    useMutation((formData) => Put_Update_Customer(formData, orgId), {
      onSuccess: (response) => {
        if (response.status === 200) {
          refetch();
          setDialogs(false);
          emptyData();
          setErrors({});
          ToastMessage(response.status, response.data.message);
        }
      },
    });

  const handleCompanyCreateAndUpdate = async (e) => {
    e.preventDefault();
    try {
      let schema = createCustomerSchema();
      await schema.validate(formData, { abortEarly: false });
      if (orgId !== -1 && isEdit === false) {
        let value = {
          ...formData,
          dialCode: formData?.dialCode?.code,
          // companyId: formData?.companyId?.code,
          squareFrameImage: formData?.squareFrameImage
            ? formData?.squareFrameImage
                .split(process.env.REACT_APP_FILE_FOLDER)
                .pop()
            : "",
          verticalFrameImage: formData?.verticalFrameImage
            ? formData?.verticalFrameImage
                .split(process.env.REACT_APP_FILE_FOLDER)
                .pop()
            : "",
        };
        const { image, ...updatedFormData } = value;
        updateCustomer(updatedFormData);
      } else {
        let value = {
          ...formData,
          dialCode: formData?.dialCode?.code,
          // companyId: formData?.companyId?.code,
          squareFrameImage: formData?.squareFrameImage
            ? formData?.squareFrameImage
                .split(process.env.REACT_APP_FILE_FOLDER)
                .pop()
            : "",
          verticalFrameImage: formData?.verticalFrameImage
            ? formData?.verticalFrameImage
                .split(process.env.REACT_APP_FILE_FOLDER)
                .pop()
            : "",
          // roleId: formData?.roleId?.code,
          // companyId: formData?.companyId?.code,
          squareFrameImage: formData?.squareFrameImage
            ? formData?.squareFrameImage
                .split(process.env.REACT_APP_FILE_FOLDER)
                .pop()
            : "",
          verticalFrameImage: formData?.verticalFrameImage
            ? formData?.verticalFrameImage
                .split(process.env.REACT_APP_FILE_FOLDER)
                .pop()
            : "",
        };
        const { image, ...updatedFormData } = value;
        createCustomer(updatedFormData);
      }
    } catch (error) {
      const validationErrors = {};
      error.inner.forEach((validationError) => {
        validationErrors[validationError.path] = validationError.message;
      });
      setErrors(validationErrors);
      if (Object.keys(validationErrors)[0]) {
        const inputField = document.getElementsByName(
          Object.keys(validationErrors)[0]
        );
        inputField[0].focus();
      }
    }
  };

  const { mutate: uploadImage, isLoading: imageLoading } = useMutation(
    (file) =>
      Upload_Image(file, setdialogsModal, setFormData, FileType.SYSTEM_IMAGE),
    {
      onSuccess: ({
        data: {
          status,
          payload: { imageUrl, baseUrl },
        },
      }) => {
        if (status === 200) {
          setFormData((prev) => {
            if (prev.imgType === "squareFrameImage") {
              return {
                ...prev,
                squareFrameImage: baseUrl + imageUrl,
              };
            }
            if (prev.imgType === "verticalFrameImage") {
              return {
                ...prev,
                verticalFrameImage: baseUrl + imageUrl,
              };
            }
          });
        }
      },
    }
  );

  /**
   *
   * @param {get {value} and {name}} e
   * input value change
   */

  const handleChangeCustomer = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
    setErrors((prev) => {
      return {
        ...prev,
        [name]: "",
      };
    });
  };

  const search = (e) => {};

  /**
   * delete company image
   */
  const { mutate: postsDelete, isLoading: isLoadingDelete } = useMutation(
    (imgData) => DELETE_IMAGE(imgData, refetch)
  );

  const accept = (imgType) => {
    let imgData = {
      fileName: formData[`${imgType}`]
        .split(`${process.env.REACT_APP_FILE_FOLDER}`)
        .pop(),
    };
    setFormData((prev) => {
      return {
        ...prev,
        [`${imgType}`]: "",
      };
    });
    postsDelete(imgData);
  };

  const openImageUploadModal = async (e, imgType) => {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = (_event) => {
      setFormData((prev) => {
        return {
          ...prev,
          [imgType]: reader.result,
          imgType,
        };
      });
    };
    await uploadImage(e.target.files[0]);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  return (
    <Fragment>
      <Dialog
        header={isEdit ? CreateCustomerTitle : UpdateCustomerTitle}
        className="modal_style"
        visible={dialog}
        position="top"
        onHide={() => handleOpenandClosePopup(false)}
        draggable={false}
        resizable={false}
      >
        <IsLoadingResponse
          isLoading={
            createCompanyLoader ||
            updateCompanyLoader ||
            isLoadingDelete ||
            imageLoading
          }
        />
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  onSubmit={(e) => handleCompanyCreateAndUpdate(e)}
                >
                  <Row>
                    <div className="field mb-4 col-12 md:col-6">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexWrap: "wrap",
                          marginBottom: "15px",
                        }}
                      >
                        <div
                          style={{
                            height: "150px",
                            width: "185px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={
                              formData?.squareFrameImage
                                ? formData.squareFrameImage
                                : NOT_FOUND_IMAGE
                            }
                            alt=""
                            style={{
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          // display: "flex",
                          // justifyContent: "center",
                          // flexWrap: "wrap",
                        }}
                      >
                        <p>{"Upload Square Frame Image"}</p>
                        {!formData.squareFrameImage && (
                          <input
                            className="custom-file-input"
                            type="file"
                            onChange={(e) =>
                              openImageUploadModal(e, "squareFrameImage")
                            }
                          />
                        )}

                        <Button
                          className="p-button p-component p-button-outlined w-full sm:w-auto flex-order-0 sm:flex-order-1"
                          style={{ height: "40px" }}
                          type="button"
                          onClick={() => {
                            if (formData.squareFrameImage) {
                              SweetConfirmation(accept, "squareFrameImage");
                            }
                          }}
                        >
                          <span
                            className={`p-button-icon p-c p-button-icon-left pi pi-camera `}
                          ></span>
                          <span
                            className="p-button-label p-c"
                            style={{ fontWeight: "100" }}
                          >
                            {"Choose"}
                          </span>
                        </Button>
                      </div>
                    </div>
                    <div className="field mb-4 col-12 md:col-6">
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          flexWrap: "wrap",
                          marginBottom: "15px",
                        }}
                      >
                        <div
                          style={{
                            height: "150px",
                            width: "185px",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={
                              formData?.verticalFrameImage
                                ? formData.verticalFrameImage
                                : NOT_FOUND_IMAGE
                            }
                            alt=""
                            style={{
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          // display: "flex",
                          // justifyContent: "center",
                          // flexWrap: "wrap",
                        }}
                      >
                        <p>{"Upload Vertical Frame Image"}</p>
                        {!formData.verticalFrameImage && (
                          <input
                            className="custom-file-input"
                            type="file"
                            onChange={(e) =>
                              openImageUploadModal(e, "verticalFrameImage")
                            }
                          />
                        )}

                        <Button
                          className="p-button p-component p-button-outlined w-full sm:w-auto flex-order-0 sm:flex-order-1"
                          style={{ height: "40px" }}
                          type="button"
                          onClick={() => {
                            if (formData.verticalFrameImage) {
                              SweetConfirmation(accept, "verticalFrameImage");
                            }
                          }}
                        >
                          <span
                            className={`p-button-icon p-c p-button-icon-left pi pi-camera `}
                          ></span>
                          <span
                            className="p-button-label p-c"
                            style={{ fontWeight: "100" }}
                          >
                            {"Choose"}
                          </span>
                        </Button>
                      </div>
                    </div>
                    <Col md="6 mb-4">
                      <FormDataFeild
                        label={Name}
                        name="name"
                        id="name"
                        type={TYPE_FELDS.text}
                        placeholder={Name}
                        value={formData.name}
                        handleChange={handleChangeCustomer}
                      />
                      {errors.name && (
                        <span className="error-validation">{errors.name}</span>
                      )}
                    </Col>

                    <Col md="6 mb-4" className="d-flex gap-4 ">
                      <div>
                        <FormDataFeild
                          label={DialCode}
                          name="dialCode"
                          id="dialCode"
                          placeholder={DialCode}
                          value={formData.dialCode}
                          handleChange={handleChangeCustomer}
                          dropdown={true}
                          option={optionsDialCode}
                          search={search}
                        />
                        {errors.dialCode && (
                          <span className="error-validation">
                            {errors.dialCode}
                          </span>
                        )}
                      </div>
                      <div style={{ width: "100%" }}>
                        <FormDataFeild
                          label={"WhatsApp No"}
                          name="mobile"
                          id="mobile"
                          type={TYPE_FELDS.number}
                          placeholder={"WhatsApp No"}
                          value={formData.mobile}
                          handleChange={handleChangeCustomer}
                          maxlangth={TypeNumber.PHONE}
                        />
                        {errors.mobile && (
                          <span className="error-validation">
                            {errors.mobile}
                          </span>
                        )}
                      </div>
                    </Col>
                    <Col md="6 mb-4">
                      <FormDataFeild
                        label={Email}
                        name="email"
                        id="email"
                        type={TYPE_FELDS.email}
                        placeholder={Email}
                        value={formData.email}
                        handleChange={handleChangeCustomer}
                        isValid={false}
                      />
                    </Col>
                    <Col md="6 mb-4">
                      <FormDataFeild
                        label={WP_GROUP_ID}
                        name="wpGroupId"
                        id="wpGroupId"
                        type={TYPE_FELDS.text}
                        placeholder={WP_GROUP_ID}
                        value={formData.wpGroupId}
                        handleChange={handleChangeCustomer}
                        isValid={false}
                      />
                    </Col>
                    <Col md="6 mb-4">
                      <div>
                        <label
                          htmlFor="enableForGeneralPost"
                          className="font-medium text-900"
                          style={{ fontSize: "14px" }}
                        >
                          {"Enable For General Post"}
                        </label>
                      </div>
                      <InputSwitch
                        name="enableForGeneralPost"
                        id="enableForGeneralPost"
                        checked={formData.enableForGeneralPost === true}
                        onChange={handleChangeCustomer}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12 mb-4" className="btn-style">
                      <Button
                        label={Submit}
                        icon="pi pi-check"
                        loading={createCompanyLoader || updateCompanyLoader}
                        type={TYPE_FELDS.submit}
                      />
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <CropImagePopup
          dialogModal={dialogModal}
          setdialogsModal={setdialogsModal}
          image={formData?.image}
          aspect={aspect}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          setFormData={setFormData}
          uploadImage={uploadImage}
        />
      </Dialog>
    </Fragment>
  );
};

export default CustomerCreateFormPopup;
